
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../../common/controllers/screencontrollerbase.ts" />
/// <reference path="../../common/controllers/app.common.controllers.module.ts" />
/// <reference path="app.hilo.controllers.module.ts" />


module App.HiLO.Controllers {
    'use strict';

    class PredecessorOrganisationsController extends App.Common.Controllers.ScreenControllerBase {
       
        public busyPromise: angular.IPromise<any>;
        public orgs: any = [];
        public referenceDataService : App.HiLO.Services.ReferenceDataService;
        public static $inject = [
            '$injector'
            
        ];

        constructor(
            $injector: angular.auto.IInjectorService) {
            super($injector);
            this.referenceDataService = $injector.get<App.HiLO.Services.ReferenceDataService>('app.hilo.services.referenceDataService');
            this.title = 'List of predecessor organisations';
            this.titleSecondary = 'Other organisations for which we can process applications';
        }

        public beforeInitialize(): angular.IPromise<any> {
            return this.setAuthenticationRequired(false);
        }

        public initialize(): angular.IPromise<any> {
            return this.referenceDataService.getData().then((response) => {
                this.orgs = response.data;
            });
        }

    }


    angular
        .module('app.hilo.controllers')
        .controller('app.hilo.controllers.predecessorOrganisationsController', PredecessorOrganisationsController);

}